"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { useShallow } from "zustand/react/shallow";
import { Sound, usePlaySound } from "@/hooks/use-play-sound";
import { getVolumeIcon, useVolumeStore } from "@/stores/use-volume-store";
export function PageFooterVolumeToggle() {
  const $ = _c(11);
  const {
    volume,
    toggleVolume
  } = useVolumeStore(useShallow(_temp));
  const [playSelect] = usePlaySound(Sound.Select);
  let t0;
  if ($[0] !== volume) {
    t0 = getVolumeIcon(volume);
    $[0] = volume;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const IconComponent = t0;
  let t1;
  if ($[2] !== playSelect || $[3] !== toggleVolume) {
    t1 = () => {
      toggleVolume();
      playSelect();
    };
    $[2] = playSelect;
    $[3] = toggleVolume;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== IconComponent) {
    t2 = <IconComponent fill="interactive-secondary-styles" />;
    $[5] = IconComponent;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== volume) {
    t3 = <Button className="size-5 p-0" onClick={t1} size="xs" value={volume} variant="ghost">{t2}</Button>;
    $[7] = t1;
    $[8] = t2;
    $[9] = volume;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}
function _temp(state) {
  return {
    volume: state.volume,
    toggleVolume: state.toggleVolume
  };
}